export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/message.d7fe9409-86b9b6.svg";